import Entregas from "./Entregas";
export default Entregas;